import React from "react";

const Home = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <path
      stroke="currentColor"
      d="M12 2l-9 8v13h6v-7h6v7h6V10z"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Home;



// WEBPACK FOOTER //
// ./src/theme/icons/Home.js